module.exports = __webpack_public_path__ + "img/letter-icon.c528d5ad.svg";